import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import initialState, { Bucket, BucketState } from "../schemas/buckets.schema";
import axios from "axios"; // Assuming you're using axios for API calls
import api from "../../services/axios";

// Async thunk for fetching buckets
export const fetchBuckets = createAsyncThunk(
  "buckets/fetchBuckets",
  async (
    params: {
      search?: string;
      project_state?: string;
      from?: string;
      to?: string;
      page?: number;
      limit?: number;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(processingApiBuckets());

      const response = await api.get("recursos/bucket", {
        params: {
          search: params.search || "",
          project_state: params.project_state || "",
          from: params.from || "",
          to: params.to || "",
          page: params.page || 0,
          limit: params.limit || 10,
        },
      });

      dispatch(loadBuckets(response.data));
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(errorInLoadBuckets(errorMessage));
        return rejectWithValue(errorMessage);
      }
      dispatch(errorInLoadBuckets("An unexpected error occurred"));
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

const bucketSlice = createSlice({
  name: "buckets",
  initialState: initialState,
  reducers: {
    loadBuckets: (state, action: PayloadAction<BucketState>) => {
      state.buckets = action.payload.buckets;
      state.meta = action.payload.meta;
      state.loading = false;
      state.error = null;
    },
    errorInLoadBuckets: (state, action: PayloadAction<string>) => {
      state.buckets = [];
      state.loading = false;
      state.meta = null;
      state.error = action.payload;
    },
    changePaginated: (
      state,
      action: PayloadAction<{ page: number; limit: number }>
    ) => {
      state.paginated = action.payload;
      state.loading = false;
    },
    selectedBucket: (state, action: PayloadAction<Bucket>) => {
      state.selected = action.payload;
      state.loading = false;
    },
    processingApiBuckets: (state) => {
      state.loading = true;
      state.error = null;
      state.selected = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuckets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuckets.fulfilled, (state, action) => {
        state.buckets = action.payload.buckets;
        state.meta = action.payload.meta;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBuckets.rejected, (state, action) => {
        state.buckets = [];
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  loadBuckets,
  errorInLoadBuckets,
  changePaginated,
  processingApiBuckets,
  selectedBucket,
} = bucketSlice.actions;

export default bucketSlice.reducer;
